import { render } from "./ImportarFarmacia.vue?vue&type=template&id=8bbde23a"
import script from "./ImportarFarmacia.vue?vue&type=script&lang=js"
export * from "./ImportarFarmacia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__